export default {
  uploadInput: { display: 'none' }
}
